export default __webpack_public_path__ + "static/media/031-u turn.08809920.png";